export const STORAGE_KEYS = {
  AUTH: 'sensi-init-admin',
  CHAT_MESSAGES: 'chat-messages',
  CHAT_SETTINGS: 'chat-settings',
};
